export const setScrollPosY =  (state, y) => {
      state.scrollPosY = y;
    };
export const setScrollHeight = (state, y) => {
  state.scrollHeight = y;
}
